import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";
import { GetBeforeAndAfterHitRanges } from "../../Calculators/RangeSplitter";

export default function Summary_2_Header({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  let splitRanges = GetBeforeAndAfterHitRanges(item?.scale.ranges);
  const filledPart =
    ((elementScore - splitRanges.hitRange?.start) / (splitRanges.hitRange?.end - splitRanges.hitRange?.start)) * 100;

  // Compact name styles
  const nameStyle = {
    fontSize: isSub ? "12px" : "14px",
    fontWeight: "600",
    padding: "1px 6px",
    textAlign: "left",
    lineHeight: "1.1",
    display: "flex",
    alignItems: "center",
  };

  // Container style with borders
  const containerStyle = {
    borderLeft: "3px solid #f6c344",
    borderRight: "3px solid #f6c344",
    borderRadius: "6px",
    padding: "3px 8px",
    backgroundColor: "#e7e7e7",
  };

  return (
    <Row
      style={{
        height: "auto",
        marginBottom: "4px",
        padding: "0",
      }}
    >
      <div style={containerStyle}>
        <Row className="align-items-center" style={{ margin: "0", display: "flex", alignItems: "center" }}>
          <Col xs={4}>
            <Row style={{ margin: "0" }}>
              <Col xs="auto" style={nameStyle}>
                {item.name}
              </Col>
              <Col xs="auto" style={{ padding: "0", display: "flex", alignItems: "center" }}>
                <div
                  className={
                    (!isSub ? "_main-scope-score-header-pdf-detail-new" : "_sub-scope-score-pdf") + " _flex-center"
                  }
                >
                  {elementScore}
                </div>
              </Col>
            </Row>
          </Col>

          <Col xs={8} className={"align-content-center"} style={{ paddingRight: "22px" }}>
            <Row>
              {splitRanges.beforeHitRangeList.map((range, i) => {
                return (
                  <Col key={"b" + i} className={" px-0 align-content-center"}>
                    <ProgressBar
                      style={{
                        height: isSub ? "5.5px" : "8.3px",
                        margin: "0 1px",
                        backgroundColor: "#ffffff",
                      }}
                      now={100}
                    ></ProgressBar>
                  </Col>
                );
              })}
              <Col className={" p-0 align-content-center"}>
                <ProgressBar
                  style={{
                    height: isSub ? "5.5px" : "8.3px",
                    margin: "0 1px",
                    backgroundColor: "#ffffff",
                  }}
                  now={filledPart}
                ></ProgressBar>
              </Col>
              {splitRanges.afterHitRangeList.map((range, i) => {
                return (
                  <Col key={"a" + i} className={" px-0 align-content-center"}>
                    <ProgressBar
                      style={{
                        height: isSub ? "5.5px" : "8.3px",
                        margin: "0 1px",
                        backgroundColor: "#ffffff",
                      }}
                      now={0}
                    ></ProgressBar>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
    </Row>
  );
}
